import React from 'react';
import { formatCurrency } from '@futurefamily/ef-utils';
import styled from 'styled-components';
import { usePropagateTreatmentFormValues, Select as DSelect, SelectExtras } from '@futurefamily/ef-components';
import { treatments } from 'constants/treatments';

const Select = styled(DSelect)`

  ${SelectExtras.SelectPositionContext} {
    margin-top: 15px;
  }
`

function TreatmentSelect (props) {
  usePropagateTreatmentFormValues(treatments);

  return (
    <Select
      name="treatment"
      label="What package are you interested in?"
      {...props}
    >
      <option value="">Select one</option>
      {treatments.map(treatment => (
        <option key={treatment.value} value={treatment.value}>{treatment.name} ${formatCurrency(treatment.cost)}</option>
      ))}
    </Select>
  );
}

export default TreatmentSelect;
